module.exports = __webpack_public_path__ + "media/images/flags/4x3/cxr-e5097191315895bfe81b061d61e5f879.svg";